import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { isAddHopePurchase } from 'common/utilities/orderStatusUtils';

export const getOrderProgressBarJSX = params => {
  const { orderDetails } = params;
  const { isMobileView } = orderDetails;

  return (
    <div className={`col-12 orderProcessingProgressBar`} data-testid='orderConfirmItems-component'>
      <div className='orderProcessingProgressBarContainer col-12'>
        <div className={`col-12 current-order-status`}>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CURRENT_ORDER)}
        </div>

        <div className='col-12 progress-bar-cont'>
          <div id='progressBarContainer' className={`col-sm-6 col-10 progress-bar-container`}>
            <div id='progressBar' className='progress-bar' data-testid='load-component'></div>
          </div>
        </div>

        <div className='progress-bar-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.PROCESSING)}</div>

        {isMobileView && (
          <div className='confirm-order-text'>
            {translateWithI18Next(
              isAddHopePurchase() ? TRANSLATE_MAPPING_KEY?.HANG_TIGHT : TRANSLATE_MAPPING_KEY?.PROCESSING_YOUR,
            )}
          </div>
        )}

        {isMobileView && (
          <div className='confirm-order-text'>
            {translateWithI18Next(
              isAddHopePurchase() ? TRANSLATE_MAPPING_KEY?.CONFIRMING : TRANSLATE_MAPPING_KEY?.ORDER_READY_IN_JUST,
            )}
          </div>
        )}

        {isMobileView && (
          <div className='confirm-order-text'>
            {translateWithI18Next(
              isAddHopePurchase() ? TRANSLATE_MAPPING_KEY?.YOUR_PAYMENT : TRANSLATE_MAPPING_KEY?.A_SECOND_TEXT,
            )}
          </div>
        )}

        {!isMobileView && (
          <div className='confirm-order-text-cont col-12'>
            <div className='confirm-order-text col-6'>
              {translateWithI18Next(
                isAddHopePurchase()
                  ? TRANSLATE_MAPPING_KEY?.PROCESSING_ADD_HOPE_PAYMENT
                  : TRANSLATE_MAPPING_KEY?.PROCESSING_ORDER,
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
